import * as React from 'react';
import { Styler } from '@honeycomb/ui-core';
import { TravelRepublicLogo } from './images/logos/TravelRepublicLogo';

export function Logo(): React.JSX.Element {
    return (
        <>
            <Styler display={{ m: 'none' }}>
                <TravelRepublicLogo h={18} va="middle" />
            </Styler>
            <Styler display={{ xs: 'none', m: 'block' }}>
                <TravelRepublicLogo h={30} va="middle" />
            </Styler>
        </>
    );
}
